export default "__VITE_ASSET__COMAARFv__"